import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "space-y-1" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = {
  target: "_blank",
  rel: "noopener noreferrer",
  class: "flex space-x-1",
  href: "https://goo.gl/maps/hZmbsFypDA9fj5k48"
}
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = {
  key: 0,
  class: "absolute z-20 flex items-center justify-center w-5 h-5 rounded-full -top-2 -right-2 bg-primary-500"
}

import { CheckIcon, MapPinIcon, PhoneIcon } from "@heroicons/vue/24/outline";

// import { useRouter } from 'vue-router';
import { computed } from 'vue';

// const router = useRouter();


export default /*#__PURE__*/_defineComponent({
  __name: 'BranchCard',
  props: {
    selectedBranchId: {
        type: Number,
        default: null,
    },
    item: {
        type: Object,
        default: null
    }
},
  setup(__props) {

// import BookingLayout from '@/layouts/BookingLayout.vue';
// import ButtonComponent from '@/components/ButtonComponent.vue';


const storageUrl = computed(() => process.env.VUE_APP_API_STORAGE_URL);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["relative py-5 px-[18px] rounded-[15px] flex items-center space-x-5 bg-white cursor-pointer", __props.selectedBranchId == __props.item.id ? 'ring-[3px] ring-primary-500' : ''])
  }, [
    _createElementVNode("img", {
      src: __props.item.image_path ? __props.item.full_image_path : '/assets/images/shinagawa-bgc-branch.jpeg',
      class: "w-[110px] h-[110px] object-cover rounded-[5px] flex-shrink-0"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(__props.item.name || 'Shinagawa BGC'), 1),
      _createElementVNode("a", _hoisted_4, [
        _createVNode(_unref(MapPinIcon), { class: "w-[18px] h-[18px] flex-shrink-0 text-primary-500 mt-0.5" }),
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.item.address_line || '--'), 1)
      ]),
      _createElementVNode("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        class: "flex space-x-1",
        href: `tel:${__props.item.mobile_number}`
      }, [
        _createVNode(_unref(PhoneIcon), { class: "w-[18px] h-[18px] flex-shrink-0 text-primary-500 mt-0.5" }),
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.item.mobile_number || '--'), 1)
      ], 8, _hoisted_6)
    ]),
    (__props.selectedBranchId == __props.item.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_unref(CheckIcon), { class: "w-3 h-3 text-white" })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})